/** @format */

import { toPng } from "html-to-image";
import moment from "moment";
import qs from "query-string";
import React from "react";
import { useGeneralState } from "../state/useGeneralState";
import { PaymentMethod, PaymentMethodDescriptior } from "./PaymentMethods";

function Success({
    currency,
    merchant,
    user,
    customerName,
    customerEmail,
    amount,
    sumTotal,
    handleCloseModal,
    reference,
    redirectWhenCancelledUrl,
    redirectWhenSuccessfulUrl,
}) {
    const { method } = useGeneralState();
    const elementRef = React.useRef(null);

    const normalizeUrl = (url) => {
        try {
            if (url.includes('%')) {
                const decoded = decodeURIComponent(url);
                return decoded;
            }
            return url;
        } catch (error) {
            console.warn("Invalid URL passed to normalizeUrl:", url);
            return url;
        }
    };

    return (
        <div ref={elementRef} className="container">
            <div className="receipt-modal">
                <div className="">
                    <div className="pt-10 flex justify-center">
                        <svg width="67" height="67" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M33.5 4.1875C41.2742 4.1875 48.7299 7.27577 54.2271 12.7729C59.7242 18.2701 62.8125 25.7258 62.8125 33.5C62.8125 41.2742 59.7242 48.7299 54.2271 54.2271C48.7299 59.7242 41.2742 62.8125 33.5 62.8125C25.7258 62.8125 18.2701 59.7242 12.7729 54.2271C7.27577 48.7299 4.1875 41.2742 4.1875 33.5C4.1875 25.7258 7.27577 18.2701 12.7729 12.7729C18.2701 7.27577 25.7258 4.1875 33.5 4.1875ZM29.8485 39.2829L23.3369 32.7672C23.1035 32.5338 22.8264 32.3486 22.5214 32.2222C22.2164 32.0959 21.8895 32.0309 21.5593 32.0309C21.2292 32.0309 20.9023 32.0959 20.5973 32.2222C20.2923 32.3486 20.0152 32.5338 19.7817 32.7672C19.3103 33.2386 19.0454 33.8781 19.0454 34.5448C19.0454 35.2115 19.3103 35.8509 19.7817 36.3224L28.073 44.6136C28.3058 44.8482 28.5827 45.0344 28.8878 45.1615C29.1929 45.2886 29.5201 45.354 29.8506 45.354C30.1811 45.354 30.5083 45.2886 30.8134 45.1615C31.1185 45.0344 31.3954 44.8482 31.6282 44.6136L48.7969 27.4407C49.0335 27.2082 49.2217 26.9312 49.3507 26.6257C49.4796 26.3201 49.5468 25.992 49.5483 25.6604C49.5499 25.3287 49.4858 25 49.3596 24.6933C49.2335 24.3865 49.0479 24.1078 48.8135 23.8731C48.5791 23.6385 48.3006 23.4525 47.994 23.326C47.6874 23.1996 47.3588 23.135 47.0272 23.1362C46.6955 23.1373 46.3673 23.2041 46.0616 23.3328C45.7559 23.4614 45.4787 23.6492 45.2459 23.8855L29.8485 39.2829Z" fill="#1EC66E"/>
                        </svg>
                    </div>
                    <h3 className="my-3 text-center">
                        {merchant?.ent_type === "RELIGIOUS"
                            ? "Thank You"
                            : "Congratulations"}
                    </h3>
                    <p className="mb-2 text-center">
                        Your{" "}
                        {merchant?.ent_type === "RELIGIOUS"
                            ? "giving"
                            : "payment"}{" "}
                        of{" "}
                        <span className="font-bold">
                            {currency?.symbol}
                            {Number(sumTotal).toFixed(2)}
                        </span>{" "}
                        was successful
                    </p>
                </div>
                <div className="main">
                    <table>
                        <tr className="px-3">
                            <td>Transaction Type</td>
                            <td>
                                {
                                    PaymentMethodDescriptior[
                                        `${method ?? PaymentMethod.PayWithXCEL}`
                                    ]
                                }
                            </td>
                        </tr>
                        <tr className="px-3">
                            <td>Transaction Reference</td>
                            <td>{reference}</td>
                        </tr>
                        <tr className="px-3">
                            <td>Name</td>
                            <td>
                                {user?.first_name ?? customerName ?? ""}{" "}
                                {user?.last_name ?? ""}
                            </td>
                        </tr>

                        <tr className="px-3">
                            <td>
                                {merchant?.ent_type === "RELIGIOUS"
                                    ? "Beneficiary"
                                    : "Merchant"}
                            </td>
                            <td>{merchant?.reg_name}</td>
                        </tr>
                        {/* {!isCard && (
              <tr className="px-3">
                <td>Account No.</td>
                <td>
                  {method === "xcel"
                    ? merchant?.account?.accountNumber
                    : merchant?.bank?.account_no}
                </td>
              </tr>
            )} */}
                        <tr className="px-3">
                            <td>Amount</td>
                            <td>
                                {currency?.symbol}
                                {Number(sumTotal).toFixed(2)}
                            </td>
                        </tr>

                        <tr className="px-3">
                            <td>Status</td>
                            <td>Successful</td>
                        </tr>
                        <tr className="px-3">
                            <td>Date</td>
                            <td>{moment().format("YYYY-MM-DD")}</td>
                        </tr>

                        <tr className="px-3">
                            <td>Time</td>
                            <td>{moment().format("hh:mm A")}</td>
                        </tr>
                    </table>
                </div>
                <div>
                    <div className="footer">
                        {/* <a
                            className="bg-[#fff] hover:bg-[#fff] border-[#979797] border-[1px] text-[#979797] font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full text-center no-underline"
                            type="button"
                            href={
                                redirectWhenSuccessfulUrl || 'https://xcelapp.com/'
                            }>
                            {" "}
                            Close
                        </a> */}
                        <a
                            className="bg-[#fff] hover:bg-[#fff] border-[#979797] border-[1px] text-[#979797] font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full text-center no-underline"
                            type="button"
                            href={
                                redirectWhenSuccessfulUrl
                                    ? normalizeUrl(redirectWhenSuccessfulUrl)
                                    : 'https://xcelapp.com/'
                            }
                        >
                            Close
                        </a>

                        <button
                            className="bg-[#0095FF] hover:bg-[#0095FFb6] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                            type="button"
                            onClick={() => {
                                toPng(elementRef.current, { cacheBust: false })
                                    .then((dataUrl) => {
                                        const link =
                                            document.createElement("a");
                                        link.download = "receipt.png";
                                        link.href = dataUrl;
                                        link.click();
                                    })
                                    .catch((err) => {
                                        
                                    });
                            }}>
                            {" "}
                            Download Receipt
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Success;
